
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import GoodsCategoryForm from '@/views/goodsManage/commodity/template/GoodsCategoryForm.vue'
import { getGoodsCategoryList, GoodsCategoryListDto } from '@/api/commodity'
import { categoryDto } from '@/api/goods'

@Component({
  components: {
    GoodsCategoryForm
  }
})
export default class Rules extends Vue {
  @Prop({default: ''}) type?: string
  @Prop({default: ''}) categoryId?: string
  $refs!: {
    goodsCategoryForm: GoodsCategoryForm
  }
  showRules = false
  value = 0
  firstLevelIndex = 0
  firstLevel: any = {} // 当前选中的一级分类
  secondLevel = [] // 二级分类数据
  selectedCategoryId = '' // 当前选中的商品分类ID
  selectedCategory: categoryDto = {} // 当前选中的商品分类
  // relationId=''

  companyId = 'A1'
  goodsList: GoodsCategoryListDto[] | Record<string, any> = []

  @Watch('categoryId', {immediate: true})
  onCategoryId () {
    if (!this.selectedCategoryId) {
      this.selectedCategoryId = this.categoryId
    }
  }

  created () {
    // this.relationId=this.$route.query.relationId as string
    this.getInfo()
  }

  get isSelect () {
    return this.type === 'select'
  }

  handleBack () {
    this.$emit('on-cancel')
  }

  handleHomeBack () {
    this.$confirmDialog.show({
      okText: '确认',
      cancelText: '取消',
      tips: '现在退出则不会保存已修改内容，是否确认退出?',
      onOk: () => {
        this.$goHomeBack()
      },
    })
  }

  handleCancel () {
    this.showContent(0)
    this.setSelectedData(this.firstLevel.categoryId, this.firstLevel)
    this.handleSave()
  }

  getInfo () {
    const params = {
      pageIndex: 1,
      categoryLevel: 0,
      pageSize: 999,
      isPage: false
    }
    getGoodsCategoryList(params).then((res) => {
      this.goodsList = res.data || []
      this.initAllCategory()
      this.initSelectedCategory()
      this.showContent(this.firstLevelIndex)
    })
  }

  initSelectedCategory () {
    const deepFn = (data: GoodsCategoryListDto[] | Record<string, any>) => {
      data.forEach(item => {
        if (item.categoryId === this.categoryId) {
          this.selectedCategory = item
          return false
        }
        if (item.children) {
          deepFn(item.children)
        }
      })
    }
    deepFn(this.goodsList)
  }

  initAllCategory () {
    const children = [].concat.apply([], (
        this.goodsList.map((item: GoodsCategoryListDto) => {
          if (item.children) return item.children
        }).filter(Boolean)
    ))
    this.goodsList.unshift({
      categoryName: '全部',
      categoryId: 'all',
      categoryLevel: '1',
      children
    })
  }

  tianjia (level = 0, categoryObj?: GoodsCategoryListDto) {
    this.$refs.goodsCategoryForm.showModal(level, categoryObj)
  }

  // getInfo(){
  //   getGoodsCategoryList({ companyId: this.companyId, }).then(res => {
  //     this.goodsList = res.data[0] || {}
  //
  //   })
  //}

  // 点击左侧导航获取分类的详细商品分类
  showContent (index) {
    if (index < 0) return false
    this.firstLevelIndex = index
    this.firstLevel = this.goodsList[index]
    this.secondLevel = this.goodsList[index].children
    console.log(this.secondLevel)
  }

  show () {
    this.showRules = true
  }

  closeRules () {
    this.showRules = false
  }

  selectGoodsCategory (data: categoryDto) {
    // if (!this.isSelect) return false
    if (data.categoryId === this.selectedCategoryId) {
      if (this.isSelect) {
        this.setSelectedData(this.firstLevel.categoryId, this.firstLevel)
      } else {
        this.setSelectedData('', {})
      }
      return false
    }
    this.setSelectedData('', {})
    if (data.children && data.children.length && !this.isSelect) return false
    this.setSelectedData(data.categoryId, data)
  }

  setSelectedData (categoryId: string, category: any) {
    this.selectedCategoryId = categoryId
    this.selectedCategory = category
  }

  handleSave () {
    if (!this.selectedCategoryId) {
      this.setSelectedData(this.firstLevel.categoryId, this.firstLevel)
    }
    this.$emit('on-select', this.selectedCategory)
    this.handleBack()
  }
}
